/**
 * Return Distribution Mock
 *
 * Histogram showing the distribution of final returns across
 * Monte Carlo simulations, with the original backtest return
 * marked for comparison.
 */

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ReferenceLine,
  ResponsiveContainer,
  Cell,
} from 'recharts';

const bins = [
  { range: '-15%', count: 8, midpoint: -15 },
  { range: '-10%', count: 22, midpoint: -10 },
  { range: '-5%', count: 45, midpoint: -5 },
  { range: '0%', count: 85, midpoint: 0 },
  { range: '+5%', count: 142, midpoint: 5 },
  { range: '+10%', count: 198, midpoint: 10 },
  { range: '+15%', count: 215, midpoint: 15 },
  { range: '+20%', count: 178, midpoint: 20 },
  { range: '+25%', count: 125, midpoint: 25 },
  { range: '+30%', count: 72, midpoint: 30 },
  { range: '+35%', count: 35, midpoint: 35 },
  { range: '+40%', count: 12, midpoint: 40 },
];

const tipStyle = {
  background: 'rgba(17,24,39,0.95)',
  border: '1px solid rgba(75,85,99,0.5)',
  borderRadius: 6,
  fontSize: 11,
  fontFamily: 'ui-monospace, monospace',
};

export default function ReturnDistributionMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header">
        <span className="dot" /> Return Distribution &mdash; 1,000 Simulations
      </div>
      <div className="platform-mock-body" style={{ padding: '0.75rem' }}>
        <ResponsiveContainer width="100%" height={150}>
          <BarChart data={bins} margin={{ top: 8, right: 8, bottom: 4, left: 4 }}>
            <XAxis
              dataKey="range"
              tick={{ fill: '#64748b', fontSize: 8 }}
              axisLine={false}
              tickLine={false}
              interval={1}
            />
            <YAxis
              tick={{ fill: '#64748b', fontSize: 8 }}
              axisLine={false}
              tickLine={false}
            />
            <Tooltip
              contentStyle={tipStyle}
              formatter={(v: number) => [v, 'Simulations']}
              labelFormatter={(l) => `Return: ${l}`}
              cursor={{ fill: 'rgba(255,255,255,0.05)' }}
            />
            <ReferenceLine
              x="+20%"
              stroke="#f59e0b"
              strokeWidth={1.5}
              strokeDasharray="4 3"
              label={{ value: 'Backtest: +22%', fill: '#f59e0b', fontSize: 9, position: 'top' }}
            />
            <Bar dataKey="count" radius={[2, 2, 0, 0]} isAnimationActive={false}>
              {bins.map((bin) => (
                <Cell
                  key={bin.range}
                  fill={bin.midpoint >= 0 ? '#22c55e22' : '#ef444422'}
                  stroke={bin.midpoint >= 0 ? '#22c55e66' : '#ef444466'}
                  strokeWidth={0.5}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>

        <div style={{
          display: 'flex', justifyContent: 'center', gap: '1.5rem', marginTop: '0.25rem',
          fontSize: '0.5625rem', color: '#94a3b8',
        }}>
          <span>Mean: <strong style={{ color: '#22c55e' }}>+15.2%</strong></span>
          <span>Median: <strong style={{ color: '#22c55e' }}>+14.8%</strong></span>
          <span>Std Dev: <strong style={{ color: '#e5e7eb' }}>12.3%</strong></span>
        </div>
      </div>
      <div className="platform-mock-caption">
        The backtest return (+22%) sits right of centre — luckier than the median simulation.
      </div>
    </div>
  );
}
